/**
 * DataTable type
 * @param {object} headers - Headers
 */
export default function ({
	page = 1, sort, sortBy, sortDesc,
} = {}) {
	this.page = parseInt(page || 1, 10)
	this.sortBy = sortBy
	this.sortDesc = sortDesc

	if (sort) {
		this.sortBy = sort.replace(/^-/, '')
		this.sortDesc = sort.substr(0, 1) === '-'
	}
}
